module.exports = __webpack_public_path__ + "app/kiss-order/list-kiss-orders-3K3uCHew.html";